const Routes = [
  {
    path: '/route-planning',
    name: 'RoutePlanning',
    component: () => import('@/app/route_planning/TheRoutePlanning'),
    redirect: '/route-planning/',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '',
        component: () => import('@/app/route_planning/views/Index')
      }
    ]
  }
]

export default Routes



// WEBPACK FOOTER //
// ./src/app/route_planning/Routes.js